import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'
import { openStompunkt } from './page'
import { fullIdFromId } from '../selectors/stompunkt'

/* void function ComponentDidMountSimulation() {

	useEffect(() => {
		var savedTitle = document.title;
		document.title = 'I have changed the title!';
		return ( ()=>{
			document.title = savedTitle;
		 });
	  });
} */

export const openSearch = createActionCreator(actions.OPEN_SEARCH)

export const closeSearch = createActionCreator(actions.CLOSE_SEARCH)

export const changeSearchTerm = createActionCreator(actions.CHANGE_SEARCH_TERM, 'term')

export function searchStompunkt() {
	return function(dispatch, getState) {
		const stompunktId = fullIdFromId(getState().search.term)
		dispatch(openStompunkt(stompunktId, "sök"))
	}
}



// WEBPACK FOOTER //
// ./src/actionCreators/search.js